import { useState } from 'react';
import { imageBasePath } from 'constants';
const CopyComponent = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text || '');
      setCopied(true);

      // reset status after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Error al copiar: ', err);
    }
  };
  return (
    <>
      <p>{text}</p>
      <img
        className="copyText"
        onClick={handleCopy}
        src={imageBasePath + 'copy_icon.svg'}
        alt="copy"
        style={{ cursor: 'pointer', width: '1.2rem' }}
      />
      {copied && <p style={{ color: 'green' }}>Copied!</p>}
    </>
  );
};

export default CopyComponent;
